import Vue from 'vue'
import * as Sentry from '@sentry/vue'
import configs from '@/config'
import store from '@/vuex/store'
import LeaderboardApi from '@/api/leaderboard'

let resource = null

const actions = {
  addPoints: {
    method: 'POST',
    url: `${configs.baseUrl}/api/answer`,
  },
  getGroupTypeAnswer: {
    method: 'GET',
    url: `${configs.baseUrl}/api/answer`,
  },
  acceptTypeAnswerGroup: {
    method: 'POST',
    url: `${configs.baseUrl}/api/answer/quiz-type-answer/{slideId}/accept`,
  },
  acceptTypeAnswerGroupV2: {
    method: 'POST',
    url: `${configs.baseUrl}/api/live/answer/quiz-type-answer/{slideId}/accept`,
  },
  acceptTypeAnswerGroupV2NewKafka: {
    method: 'POST',
    url: `${configs.baseUrl}/api/${configs.LiveProxyRootPath}/answer/quiz-type-answer/{slideId}/accept`,
  },
  removeWordCloudAnswer: {
    method: 'POST',
    url: `${configs.baseUrl}/api/slide-option/remove-wordcloud`,
  },
  removeWordCloudAnswerViaLiveApi: {
    method: 'DELETE',
    url: `${configs.baseLiveApiUrl}/api/stream/answers/wordcloud`,
  },
  removeWordCloudAnswerViaLiveProxy: {
    method: 'DELETE',
    url: `${configs.liveProxyUrl}/api/live/answers/wordcloud`,
  },
  removeWordCloudAnswerViaLiveProxyNewKafka: {
    method: 'DELETE',
    url: `${configs.liveProxyUrl}/api/${configs.LiveProxyRootPath}/answers/wordcloud`,
  },

  addManualPointV2: {
    method: 'POST',
    url: `${configs.baseUrl}/api/score`,
  },

  createWordCloudSampleAnswerViaLiveProxy: {
    method: 'POST',
    url: `${configs.liveProxyUrl}/api/live/answers/wordcloud`,
  },
  createWordCloudSampleAnswerViaLiveProxyNewKafka: {
    method: 'POST',
    url: `${configs.liveProxyUrl}/api/${configs.LiveProxyRootPath}/answers/wordcloud`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const addPoints = async (params) => {
  if (store.getters['leaderboard/canUseNewLeaderboard'] && params.point) {
    // Await first — the success refresh POSTs a recomputed snapshot that would omit a not-yet-landed bonus.
    try {
      await LeaderboardApi.createBonusResult({
        presentationId: params.presentationId,
        presentationVersion: store.state.presentation.version,
        audienceId: params.audienceId,
        teamId: params.id,
        slideId: params.slideId,
        point: params.point,
      })
    } catch (error) {
      Sentry.captureException(error)
    }
  }
  if (store.getters['leaderboard/canUseLeaderboardToggleOnPresenting']) {
    const payload = {
      presentationId: params.presentationId,
      slideId: params.slideId,
      audienceId: params.audienceId,
      point: params.point,
      teamId: params.id,
    }
    const resManualPointV2 = await resource.addManualPointV2(payload)
    return {
      answer: {
        point: resManualPointV2.body.point,
      },
    }
  }
  const res = await resource.addPoints(params)
  return {
    code: res.body.code,
    answer: res.body.answer,
  }
}

const getGroupTypeAnswer = async (params) => {
  const res = await resource.getGroupTypeAnswer(params)
  return res.body
}

const acceptTypeAnswerGroup = async (slideId, params = {}) => {
  if (store.getters['liveStatsV2/canUseLiveStatsForQuizV2']) {
    const res = await resource.acceptTypeAnswerGroupV2({ slideId }, params)
    return res.body
  }
  const res = await resource.acceptTypeAnswerGroup({ slideId }, params)
  return res.body
}

const removeWordCloudAnswer = async (params) => {
  if (store.getters['liveStatsV2/canUseWordCloudLiveProxy']) {
    const res = await resource.removeWordCloudAnswerViaLiveProxy({}, params)
    return res.body
  }
  if (store.getters['liveStatsV2/canUseWordCloudEmqx']) {
    const res = await resource.removeWordCloudAnswerViaLiveApi({}, params)
    return res.body
  }
  const res = await resource.removeWordCloudAnswer(params)
  return res.body
}

const createWordCloudSampleAnswersViaLiveProxy = async (params) => {
  const res = await resource.createWordCloudSampleAnswerViaLiveProxy({}, params)
  return res.body
}

export default {
  initResource,
  addPoints,
  getGroupTypeAnswer,
  acceptTypeAnswerGroup,
  removeWordCloudAnswer,
  createWordCloudSampleAnswersViaLiveProxy,
}
